<template>
    <v-dialog v-bind="$attrs" max-width="768px" :retain-focus="false" v-on="$listeners" @click:outside="close">
        <v-card v-if="sample" class="spire-modal">
            <v-card-title>
                <h2>{{ t('spire-ftp::page.title.view-file') }} - {{ sample.file_name || null }}</h2>
                <v-icon color="#a5a5a5" @click="close()">mdi-close</v-icon>
            </v-card-title>
            <v-card-text v-if="!sample || !sample.original_data" class="pt-6">
                <b-alert type="error" :message="'The file is empty'" :dismissible="false"></b-alert>
            </v-card-text>
            <div v-if="sample && sample.original_data">
                <v-card-text class="pt-6">
                    <b-autocompleter
                        v-model="samplePatient"
                        dense
                        flat
                        outlined
                        rounded
                        :items="patinetsList"
                        :label="t('spire-ftp::label.select-patient')"
                        :cache-items="false"
                        :loading="patinetsListLoading"
                        :error-messages="samplePatientErrors"
                        :clearable="samplePatient !== null"
                        :disabled="!!sample.patient && !!sample.patient.id"
                        :hint="!!sample.patient && !!sample.patient.id ? '' : t('patients::hint.search_patients')"
                        persistent-hint
                        @change="samplePatientErrors = []"
                    ></b-autocompleter>
                </v-card-text>
                <v-card-text>
                    <div class="file-preview">
                        <div class="copy">
                            {{ sample.original_data }}
                        </div>
                    </div>
                </v-card-text>
            </div>

            <v-card-actions>
                <v-btn color="primary" text rounded class="px-6" @click="close()"
                    >{{ t('default::button.cancel') }}
                </v-btn>
                <v-btn
                    v-if="!sample.patient && can('api.v1.spire-blood-results.assign')"
                    :disabled="!samplePatient"
                    color="primary"
                    rounded
                    :loading="loading"
                    class="px-6 ml-6"
                    @click="save()"
                    >{{ t('default::button.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            samplePatient: null,
            samplePatientErrors: [],
        };
    },
    computed: {
        tab() {
            return this.$store.state.spire.tab;
        },
        sample() {
            return this.$store.state.spire.currentSample;
        },
        loading() {
            return this.$store.state.spire.loading;
        },
        patinetsList() {
            return this.$store.state.spire.patientsOptions.map((x) => ({ value: x.id, text: x.name }));
        },
        patinetsListLoading() {
            return this.$store.state.spire.patientsOptionsLoading;
        },
    },
    watch: {
        'sample.patient.id': {
            handler: _.debounce(function (samplePatient) {
                return (this.samplePatient = samplePatient);
            }),
        },
        '$attrs.value': {
            handler: _.debounce(function (val) {
                if (val === false) {
                    this.samplePatient = null;
                    this.close();
                }
            }),
        },
    },
    created() {},
    methods: {
        async save() {
            this.$store.dispatch('spire/setSpireLoading', true);
            const data = {
                patient: this.samplePatient,
            };
            return await axios({
                method: 'put',
                url: route('api.v1.spire-blood-results.assign', {
                    spire_blood_result: this.sample.id,
                }),
                data,
            })
                .then(() => {
                    this.$root.notify(
                        'info',
                        t('spire-ftp::notification.success'),
                        t('spire-ftp::notification.linked-sample')
                    );
                    this.$store.dispatch('spire/incremetDateTableKeyMissing');
                    return this.close();
                })
                .catch((error) => {
                    this.samplePatientErrors = error.response.data.error;
                    return this.$root.notify('error', error.response.data.error);
                })
                .finally(() => _.delay(() => this.$store.dispatch('spire/setSpireLoading', false), 400));
        },
        close() {
            this.samplePatientErrors = [];
            this.$store.dispatch('spire/setPreviewModal', false);
            this.$store.dispatch('spire/resetCurrentSample');
        },
    },
};
</script>
